import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class TunnelOrientationTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (TunnelOrientationTypeModel._instance == null) TunnelOrientationTypeModel._instance = new TunnelOrientationTypeModel(authManager);
        return TunnelOrientationTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/tunnel-orientation-types', 'geo-sections/tunnel-orientation-types/codelist');

        this.entityName = 'geo-sections.TunnelOrientationType';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Tunnel Orientation Type';
        this.setLabel = 'Tunnel Orientation Types';

        this.browser = {
            name: 'default-geo-sections-tunnelorientationtype-browser',
            moduleName: 'default-geo-sections-tunnelorientationtype-browser',
            moduleTitle: 'Tunnel Orientation Types',
            moduleStateSlotName: 'default-geo-sections-tunnelorientationtype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-tunnelorientationtype-editor',
            moduleName: 'default-geo-sections-tunnelorientationtype-editor',
            moduleTitle: 'Tunnel Orientation Type',
            moduleStateSlotName: 'default-geo-sections-tunnelorientationtype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
